<template>
    <div class="mask-dialog-overlay" v-if="visible" @click="handleOverlayClick">
        <div class="mask-dialog-content" @click.stop>
            <div class="mask-dialog-closeDiv">
                <div class="leftHeadDiv">

                </div>
                <div class="centerHeadDiv">
                    {{title}}
                </div>
                <div class="rightHeadDiv">
                <span class="mask-dialog-close" @click="handleClose">&times;</span>
            </div>
            </div>
            <div class="centerDiv">
            <img src="../../../assets/serive1.jpg" v-if="title=='生态化-落地项目育成工厂'" class="centerImg" alt="">
            <img src="../../../assets/serive2.jpg" v-if="title=='精准化-供需对接推介活动'" class="centerImg" alt="">
            <img src="../../../assets/serive3.jpg" v-if="title=='专业化-诊断评价策划业务'" class="centerImg" alt="">
            <img src="../../../assets/serive4.jpg" v-if="title=='数字化-云网智能服务平台'" class="centerImg" alt="">
            <img src="../../../assets/serive5.jpg" v-if="title=='常态化-共建科创实体机构'" class="centerImg" alt="">
            <img src="../../../assets/hzserive1.jpg" v-if="title=='产业合作'" class="centerImg" alt="">
            <img src="../../../assets/hzserive2.jpg" v-if="title=='市场合作'" class="centerImg" alt="">
            <img src="../../../assets/hzserive3.jpg" v-if="title=='资本合作'" class="centerImg" alt="">
            <img src="../../../assets/hzserive4.jpg" v-if="title=='技术合作'" class="centerImg" alt="">
            </div>  

            <div @click="handleClose" class="closeFooterImgDiv">
                <img src="../../../assets/closeImg.png" class="mask-dialog-closeImg" alt="">
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'MaskSeriveDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        closeOnOverlay: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {

        }
    },
    methods: {

        handleOverlayClick() {
            if (this.closeOnOverlay) {
                this.handleClose()
            }
        },
        handleClose() {
            this.$emit('update:visible', false)
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
.closeFooterImgDiv{
    width: 100%;
    height: 90px;
    background:#0F8EF0 ;
    display: flex;
    justify-content: center;
    align-items: center;
}
.centerImg{
    width: 100%;
    height: 100%;
}
.centerDiv{
    width: 100%;
    height: 611px;
}
.centerHeadDiv{
    width: 80%;
    color: #fff;
    font-size: 30px;
    line-height: 70px;
    height: 70px;
    text-align: center;
}
.leftHeadDiv{
    width: 10%;
}



.clearfix {
    color: 000000d9;
    font-size: 16px;
    font-weight: 500;
}

.ml20 {
    margin-left: 20px;
}

.tabContentDiv {
    display: flex;
    padding-left: 20px;
}
.tabContentThree{
    width: 480px;
    height: 125px;
    background: #fff;
    border-radius: 2px;
    margin-right: 15px; 
}
.tabContentOne {
    width: 280px;
    height: 125px;
    background: #fff;
    border-radius: 2px;
    margin-right: 15px;
}

.activeTab {
    color: #1890ff !important;
}

.tabDiv {
    display: flex;
    margin-bottom: 16px;
    border-bottom: 1px solid #fff;
}

.tabItem {
    height: 40px;
    margin: 0 2px 0 0;
    padding: 0 16px;
    line-height: 38px;
    background: #fafafa;
    border-radius: 4px 4px 0 0;
    -webkit-transition: all .3s cubic-bezier(.645, .045, .355, 1);
    transition: all .3s cubic-bezier(.645, .045, .355, 1);
    font-size: 14px;
    color: #000000a6;
    cursor: pointer;
}

.formContent {
    background: #448EF7;
}

.formTitle {
    text-align: center;
    padding-top: 30px;
    font-size: 30px;
    color: #fff;
    margin-bottom: 20px;
}

.formDiv {
    position: absolute;
    left: 115px;
    top: 130px;
    padding: 0;
    margin: -20px;
    width: 970px;
    height: 540px;
    border-radius: 10px;
    background-color: #2d3b87;
    box-shadow: inset 0 0 5px rgba(5, 17, 236, .5);
    border: 2px solid #a9a9af;
}

.mt20 {
    margin-top: 25px;
}

.fontRed {
    background-image: url('../../../assets/fontRedImg.png');
    width: 302px;
    height: 116px;
    text-align: center;
    font-size: 20px;
    color: #fff;
}

.fontRed:hover {
    background-image: url('../../../assets/fontRedImgHover.png');
}

.modal_content {
    padding-top: 70px;
    margin-left: 115px;
    width: 80%;
    height: 340px;
    overflow: hidden;
    line-height: 30px;
    color: #fff;
    font-size: 14px;
}

.ml50 {
    margin-left: 50px;
}

.modal_shortRed {
    padding-left: 115px;
    display: flex;
    justify-content: space-between;
    padding-right: 115px;

}

.modal_short {
    padding-top: 150px;
    padding-left: 115px;
}

.flex {
    display: flex;
    font-size: 16px;
    line-height: 30px;
    color: #a9a9af;
}

.mask-dialog-closeDiv {
    display: flex;
    justify-content: space-between;
    height: 70px;
    background: #0F8EF0;
}

.mask-dialog-overlay {
    position: fixed;
    top: 0px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;

}

.mask-dialog-closeImg {
}

.mask-dialog-content {
    margin-top: 40px;
    width: 1100px;
    height: 100%;
}

.mask-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px;
    background: linear-gradient(135deg, #1890FF 0%, #40A9FF 100%);
    color: #fff;
}

.mask-dialog-title {
    font-size: 20px;
    font-weight: bold;
}
.rightHeadDiv{
    width: 10%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
}
.mask-dialog-close {
    font-size: 20px;
    cursor: pointer;
    line-height: 1;
    color: #fff;

}



.mask-dialog-body {
    padding: 30px;
    overflow-y: auto;
    flex: 1;
}
</style>
